/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {DefaultTitle} from './page-title/DefaultTitle'
import {Topbar} from './Topbar'
import {useAppDispatch} from "../../../../app/infrastructure/hooks/reduxHooks";
import {organisationReducerActions} from "../../../../app/pages/organisation";

export function HeaderWrapper() {
    const {config, classes, attributes} = useLayout()
    const {header, aside} = config

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const logoRedirection = () => {
        dispatch(organisationReducerActions.setSelectedOrganisation(null))
        setTimeout(() => {
            navigate('/')
        }, 50)
    }

    return (
        <div
            id='kt_header'
            className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
            {...attributes.headerMenu}
        >
            <div
                className={clsx(
                    classes.headerContainer.join(' '),
                    'container-xxl d-flex align-items-stretch justify-content-between'
                )}
            >
                {/* begin::Aside mobile toggle */}
                {aside.display && (
                    <div className='d-flex align-items-center d-lg-none ms-n3 me-1' title='Show aside menu'>
                        <div
                            className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
                            id='kt_aside_mobile_toggle'
                        >
                            <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className='svg-icon-2x mt-1'/>
                        </div>
                    </div>
                )}
                {/* end::Aside mobile toggle */}
                {/* begin::Mobile Logo */}
                {!aside.display && (
                    <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                        <span onClick={logoRedirection} className='d-lg-none cursor-pointer'>
                            <img alt='Logo' src={toAbsoluteUrl('/assets/protectremote-logo.svg')} className='h-20px'/>
                        </span>
                    </div>
                )}
                {/* end::Mobile logo */}

                {/* begin::Desktop logo */}
                <div className="d-none align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15 d-lg-flex">
                    <span onClick={logoRedirection} className="cursor-pointer">
                        <img alt="Logo" src={toAbsoluteUrl('/assets/protectremote-logo.svg')} style={{height:22}}/>
                    </span>
                </div>
                {/* end::Desktop logo */}

                {/* begin::Wrapper */}
                <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                    {/* begin::Navbar */}
                    {/*{header.left === 'menu' && (*/}
                    {/*    <div className='d-flex align-items-stretch' id='kt_header_nav'>*/}
                    {/*        <Header/>*/}
                    {/*    </div>*/}
                    {/*)}*/}

                    {/*{header.left === 'page-title' && (*/}
                    {/*    <div className='d-flex align-items-center' id='kt_header_nav'>*/}
                    {/*        <DefaultTitle/>*/}
                    {/*    </div>*/}
                    {/*)}*/}

                    {/*    ciftleme hatasi ile ilgili olarak yukaridaki alanlar kapatilip kullanilan aktif edildi */}
                        <div className='d-flex align-items-stretch' id='kt_header_nav'>
                            <Header/>
                        </div>

                    <div className='d-flex align-items-stretch flex-shrink-0'>
                        <Topbar/>
                    </div>
                </div>
                {/* end::Wrapper */}
            </div>
        </div>
    )
}
